<template>
  <div class="container-fluid p-0 h-100">
    <h3>Order Pull Schedules List</h3>
    <order-rules-grid></order-rules-grid>
  </div>
</template>

<script>
import OrderSchedulesGrid from "@/components/grids/order-schedules-grid.vue";
export default {
  components: {
    "order-rules-grid": OrderSchedulesGrid,
  },
};
</script>

<style></style>